
import { Component, Prop, Vue } from "vue-property-decorator";
import { ShortRent } from "@/enum/index";

export interface Houseplan {
  buildingName: string;
  buildingArea: string;
  isShortRent: ShortRent;
  area: number;
  flower: string;
  imgUrl: string;
  [propName: string]: string | number | object;
}

@Component
export default class HouseMin extends Vue {
  @Prop() houseplan!: Houseplan;
  render() {
    return (
      <div class="house-min">
        <div class="house-wrap">
          <img src={this.houseplan.imgUrl} />
          <div class="dec">
            <div class="title"> {this.houseplan.buildingName}</div>
            <div style="height:5px;"></div>
            <div class="dec-tag">
              <span class="dec-tip">可体验一周</span>
              <span>{ShortRent[this.houseplan.isShortRent]}</span>
              <span>{this.houseplan.buildingArea}</span>
            </div>
          </div>
          <div style="height:5px;"></div>
          <div class="info">
            <span class="info-tag info-m">
              {this.houseplan.area}m<sup>2</sup>
            </span>
            <a-divider type="vertical" />
            <span class="info-tag info-f">{this.houseplan.flower}层</span>
          </div>
          <div class="price">¥ 1500元/月</div>
        </div>
      </div>
    );
  }
}
